"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BROKER = {
    id: '00000000-0000-0000-0000-000000000001',
    dotNumber: 'ABC12345'
};
